export class FilterOptionState {
  private active: boolean;

  private count: number;

  private productScoreSum: number;

  constructor(active: boolean = false, count: number = 0, productScoreSum: number = 0) {
    this.active = active;
    this.count = count;
    this.productScoreSum = productScoreSum;
  }

  copy() {
    return new FilterOptionState(this.active, this.count, this.productScoreSum);
  }

  isActive() {
    return this.active;
  }

  toggleActivationState() {
    this.active = !this.active;
  }

  getCount(): number {
    return this.count;
  }

  getProductScoreSum(): number {
    return this.productScoreSum;
  }

  resetCount() {
    this.count = 0;
    this.productScoreSum = 0;
  }

  incCount(productScore: number) {
    this.count += 1;
    this.productScoreSum += productScore;
  }

  setCount(count: number) {
    this.count = count;
  }

  setCountAndScore(count: number, scoreSum: number) {
    this.count = count;
    this.productScoreSum = scoreSum;
  }
}
